import React, { useCallback, useEffect } from "react";
import Tabs from "src/components/Tabs/Tabs";
import "./App.css";
import LegendBox from "src/components/LegendBox/LegendBox";
import Scene from "src/components/Scene/Scene";
import StartLoader from "src/components/StartLoader/StartLoader";
import { useWindowResize } from "src/hooks/useWindowResize";
import UiHeader from "src/components/UiHeader/UiHeader";
import UiButtons from "src/components/UiButtons/UiButtons";
import TotalPrice from "src/components/TotalPrice/TotalPrice";
import SaveOfferForm from "src/components/SaveOfferForm/SaveOfferForm";
import ResultPopup from "src/components/ResultPopup/ResultPopup";
import Loader from "src/components/LoaderPopup/Loader";
import { useLoader } from "src/contexts/LoaderContext";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import InfoBox from "src/components/InfoBox/InfoBox";
import { TabScrollProvider } from "src/contexts/TabScrollContext";
import CarouselPopup from "./components/Popups/Carousel/CarouselPopup";
import { preloadPrices } from "src/hooks/usePriceLoader";

const App: React.FC = () => {
  const windowWidth = useWindowResize();
  const {
    isStartLoaderVisible,
    setIsStartLoaderVisible,
    setIsSceneLoaderVisible,
    setIsWhiteSceneLoaderVisible,
  } = useLoader();
  const { configurator, isLoaded, setIsLoaded } = useConfiguration();

  const completeHandler = useCallback(() => {
    setIsSceneLoaderVisible(false);

    if (!isLoaded && configurator.isLoaded()) {
      const configuratorScene = document.querySelector("#configurator-scene");

      // const width = configuratorScene?.getBoundingClientRect().width ?? 800;
      // const height = configuratorScene?.getBoundingClientRect().height ?? 800;
      // window.APP.resize(width, height);
      setIsLoaded(true);

      setTimeout(() => {
        const width = configuratorScene?.getBoundingClientRect().width ?? 800;
        const height = configuratorScene?.getBoundingClientRect().height ?? 800;
        window.APP.resize(width, height);

        setIsStartLoaderVisible(false);
        setIsWhiteSceneLoaderVisible(false);

        configurator.startAnimation();

        return true;
      }, 500);
    }
  }, [
    configurator,
    isLoaded,
    setIsLoaded,
    setIsSceneLoaderVisible,
    setIsStartLoaderVisible,
    setIsWhiteSceneLoaderVisible,
  ]);

  useEffect(() => {
    setIsWhiteSceneLoaderVisible(true);
    setIsStartLoaderVisible(true);

    // Preload prices on app startup
    preloadPrices();
  }, [setIsStartLoaderVisible, setIsWhiteSceneLoaderVisible]);

  useEffect(() => {
    const startHandler = () => {
      if (!isStartLoaderVisible) setIsSceneLoaderVisible(true);
    };

    configurator.getLoader().on("start", startHandler);

    return () => {
      configurator.getLoader().off("start", startHandler);
    };
  }, [configurator, isStartLoaderVisible, setIsSceneLoaderVisible]);

  useEffect(() => {
    configurator.getLoader().on("complete", completeHandler);

    return () => {
      configurator.getLoader().off("complete", completeHandler);
    };
  }, [
    setIsStartLoaderVisible,
    setIsSceneLoaderVisible,
    configurator,
    completeHandler,
  ]);

  if (new URLSearchParams(window.location.search).get("admin") === "1") {
    window.APP.scene.setPan(true);
    // console.log(
    //   "is_admin: ",
    //   new URLSearchParams(window.location.search).get("is_admin") === "1"
    // );
  }

  return (
    <>
      <StartLoader />
      <div className="configurator-container-hover">
        <div className={`configurator-hover`}>
          {windowWidth >= 768 && <UiHeader />}
          <div className={`configurator-ui-wrapper`}>
            <Scene />
            {windowWidth <= 768 && <LegendBox />}
            <div id="configurator-ui">
              <TabScrollProvider>
                <Tabs />
              </TabScrollProvider>
              <TotalPrice />
              <UiButtons />
            </div>
            {windowWidth > 768 && <LegendBox />}
            <InfoBox />
          </div>
        </div>
        <Loader />
        <SaveOfferForm />
        <ResultPopup />
        <CarouselPopup />
      </div>
    </>
  );
};

export default App;
